'use client';
import DynamicImage from '@/components/DynamicImage';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
// import { AnimatedButton } from './common/AnimatedButton';
// import RegisDialog from './regisDialog';

const Contentfivemobile = () => {
  const items = [
    {
      title: '业务增长赋能顾问',
      dsc: '定位运营问题，最全维度的诊断咨询，指定效能提升方案',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736477601367/Frame%201312321173%402x.png',
    },
    {
      title: '技术支持',
      dsc: '强大的技术保障，高效响应客户需求， 实时在线解答，降低企业的运营成本',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736477617135/Frame%201312321173%402x%20(1).png',
    },
    {
      title: '企业数据安全',
      dsc: '专属数据密钥、新型加密技术高级别加密协议、标准API接口以及私有化部署服务从源头保护企业数据安全',
      icon: 'https://osscdn.weiyouzhihui.com/editorVideo/1736477633776/Frame%201312321173%402x%20(2).png',
    },
  ];
  return (
    <section className="w-full px-[20px]">
      <motion.div
        className="text-center mb-8"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-[18px] mt-[32px] mb-[16px] font-medium text-black/85 px-[20px]">
          选择微友智汇，像好友一样服务客户 让您的私域运营更省心
        </h2>
        <div className="flex flex-col gap-[16px]">
          {items.map((item, index) => (
            <div
              key={index}
              className="w-full flex justify-start items-end bg-[#FFF6F0] rounded-[10px] h-[112px] pr-[14px]"
            >
              <div className="text-left h-full pr-[10px] flex flex-col justify-center items-start pl-[16px]">
                <p className="text-[14px] text-[rgba(0,0,0,0.85)] mb-[2px]">{item.title}</p>
                <p className="text-[12px] text-[rgba(0,0,0,0.65)]">{item.dsc}</p>
              </div>
              <DynamicImage src={item.icon} className="w-[72px] h-[102px]"></DynamicImage>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Contentfivemobile;
